import { Component } from '@angular/core';

@Component({
    selector: 'app-mmp-flag-component',
    templateUrl: './mmp-flag-component.component.html',
    standalone: true
})
export class MmpFlagComponentComponent {

}
